var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "14 14 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".info_svg__a_UC1RKXH2{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "info_svg__a_UC1RKXH2",
    d: "M0 0h44v44H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "info_svg__a_UC1RKXH2",
    d: "M10 10h24v24H10z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10 2a8 8 0 1 0 8 8 8 8 0 0 0-8-8Zm.8 12H9.2V9.2h1.6Zm0-6.4H9.2V6h1.6Z",
    transform: "translate(11.999 12)",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgInfo;